module.exports = __webpack_public_path__ + "img/cookie1.6aaa7041.jpg";